var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cart"}},[_c('nav-bar',{staticClass:"nav-bar"},[_c('div',{attrs:{"slot":"center"},slot:"center"},[_vm._v("购物车")])]),_c('cart-list',{attrs:{"test":_vm.cartList}}),_c('bottom-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }